import React from 'react';
import { useSelector } from 'react-redux';
import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { formatDate } from 'utilities/common';

export const InformationFulfillment = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Fulfillment.Show']
  );

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  return (
    <section className="border rounded-2 p-3 pt-2 mb-3" id="detail">
      <div className="fw-semibold py-2 border-bottom" style={{ fontSize: 13 }}>
        {StateLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Informasi Fulfillment'
        )}
      </div>
      <div className="row pt-2">
        {StateLoading ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <ListHorizontal
                title={<SkeletonText count={1} />}
                content={<SkeletonText count={1} />}
              />
            </div>
          ))
        ) : (
          <>
            <div className="col-12">
              <ListHorizontal title="Total Weight" content={
                <span>{(data?.total_weight / 1000)} Kg</span>
              } />
              <ListHorizontal title="Dikerjakan oleh" content={data?.fulfill_by} />
              <ListHorizontal
                title="Tanggal Pengerjaan"
                content={formatDate(data?.fulfill_at, 'DD/MM/YYYY HH:mm')}
              />

              {data?.checked_by && (
                <>
                  <ListHorizontal
                    title="Dicek oleh"
                    content={data?.checked_by}
                  />
                  <ListHorizontal
                    title="Tanggal Pengecekan"
                    content={formatDate(data?.checked_at, 'DD/MM/YYYY HH:mm')}
                  />
                </>
              )}

              <ListHorizontal
                title="Catatan"
                className="border-bottom-0"
                content={data?.note || '-'}
              />
            </div>
          </>
        )}
      </div>
    </section>
  );
};
